import { createSlice } from '@reduxjs/toolkit';

export const clipTraySlice = createSlice({
    name: "clipTray",
    initialState: {
        clips: [],
        open: false
    },
    reducers: {
        set: (state, action) => {
            state = action.payload;
            return state;
        },
    }
})

export const clipTrayActions = clipTraySlice.actions;

export default clipTraySlice.reducer;